export default "__VITE_ASSET__d926affc__"